import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VJsf from '@user-interface/vjsf/lib/VJsf.js';
import '@mdi/font/css/materialdesignicons.css'
import '@user-interface/vjsf/lib/VJsf.css';
import '@user-interface/vjsf/lib/deps/third-party.js';
import VMediaControls from '@user-interface/v-media-controls';
import {store} from './store/store';
import router from './router'
import {en} from './locales/en.js';
import VueI18n from 'vue-i18n';
import VueHotkey from 'v-hotkey'

Vue.use(VueI18n);
Vue.use(VMediaControls);
Vue.use(
  VueHotkey,
  {
    "①": 107      // Numpad +
  }
)

const messages = {
  "en": en
};

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
});


Vue.component('VJsf', VJsf);

Vue.config.productionTip = false;

new Vue({
  i18n,
  vuetify,
  store,
  router,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  render: h => h(App)
}).$mount('#app');
